<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">设备管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">考场管理</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start">
          <div class="searchbox">
            <div title="考场名称" class="searchboxItem ci-full">
              <span class="itemLabel">考场名称:</span>
              <el-input v-model="formDate.roomName" type="text" size="small" placeholder="考场名称" clearable />
            </div>
            <el-button type="primary" class="bgc-bv" round @click="getData()">查询</el-button>
            <el-button type="primary" class="bgc-bv" round @click="to_edit">新增</el-button>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              :header-cell-style="tableHeader" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
              <el-table-column label="考场名称" align="left" show-overflow-tooltip prop="roomName" minWidth="200" />
              <el-table-column label="作业类别" align="left" show-overflow-tooltip prop="workCategory" minWidth="100">
                <template slot-scope="scope">
                  {{ scope.row.workCategory ? $setDictionary("PA_WORK_CATEGORY", scope.row.workCategory) : "" }}
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="220" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="to_seeDeviceList(scope.row)">查看</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="to_edit(scope.row)">编辑</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="to_delete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
export default {
  name: "systemManage_room",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      // 检索数据
      formDate: {
        roomName: "", // 姓名
      },
    };
  },
  created() {

  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 列表数据
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        ...this.formDate
      };
      this.doFetch({
        url: "/biz/v2/room/pageList",
        params,
        pageNum,
      }, true, 10);
    },
    // 查看设备列表
    to_seeDeviceList(row) {
      this.$router.push({
        path: "/practicalAssessmentSystem/systemManage/seeDeviceList",
        query: {
          roomId: row.roomId
        }
      })
    },
    // 编辑
    to_edit(row) {
      this.$router.push({
        path: "/practicalAssessmentSystem/systemManage/room_mgt",
        query: {
          roomId: row.roomId
        }
      })
    },
    // 删除
    to_delete(row) {
      this.$confirm('您确定删除当前考场吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/biz/v2/room/delete", {
          roomId: row.roomId
        }, 3000, true, 10).then((res) => {
          this.$message.success('操作成功');
          this.getData(this.pageNum);
        });
      }).catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped></style>